import { FC } from 'react'

type BadgeProps = {
  alpha?: number
  className?: string
  color?: string
  status?: string
  dataTestId?: string
  rightMargin?: boolean
  marginNone?: boolean
}

const Badge: FC<BadgeProps> = props => {
  const { alpha = 20, className = '', color, status, dataTestId = undefined, rightMargin = false, marginNone = false } = props

  const backgroundColor = `${color}${alpha}`

  return (
    <span
      data-test-id={dataTestId}
      className={`badge badge-light ${marginNone ? '' : (rightMargin ? 'mr-2' : 'ml-2')} ${className}`}
      style={{ color, backgroundColor }}
    >
      {status}
    </span>
  )
}

export default Badge
